import { render, staticRenderFns } from "./InitialState.vue?vue&type=template&id=b581ac20&scoped=true&"
import script from "./InitialState.vue?vue&type=script&lang=js&"
export * from "./InitialState.vue?vue&type=script&lang=js&"
import style0 from "./InitialState.vue?vue&type=style&index=0&id=b581ac20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b581ac20",
  null
  
)

export default component.exports